import { PageIntro } from "@/components/site/PageIntro";
import { PricingSection } from "@/sections/PricingSection";
import { useSeo } from "@/components/site/Seo";

export default function PricingPage() {
  useSeo({
    title: "Pricing",
    description:
      "Velora Intelligence pricing — start free with core crypto intelligence, or upgrade to Premium for expanded AI analysis, presale intelligence and smart monitoring.",
    path: "/pricing",
  });
  return (
    <main data-testid="pricing-page">
      <PageIntro
        label="Pricing"
        title="Plans built for clarity"
        desc="Start free and upgrade whenever you're ready. Plans are purchased and managed inside the Velora Intelligence mobile app."
      />
      <PricingSection withHeader={false} />
    </main>
  );
}
